import { TableCell } from "@material-ui/core";
import clsx from "clsx";
import PropTypes from "prop-types";
import { ICell } from "./";
import useCellStyles from "./styles";

interface CellProps extends ICell {
  children: any;
  onClick?: (ev: any) => void;
  hasError?: boolean;
}

const Cell = ({
  children,
  dataKey,
  columnIndex = -1,
  columnData,
  rowIndex,
  rowData,
  rowHeight,
  fixedSize = false,
  className = "",
  style = {},
  onClick,
}: CellProps) => {
  const classes = useCellStyles();
  const align = columnData?.align;
  const width = columnData?.width || 96;
  const clickable = columnData?.clickable || false;
  const Component = columnData?.cellComponent;
  let customClass = rowData?.customClass || "";
  let hasError = false;
  let isNegative = false;

  let customStyle = fixedSize ? { minWidth: width, maxWidth: width } : {};
  if (rowData?.cellCustoms) {
    customStyle = { ...rowData.cellCustoms[dataKey]?.style, ...customStyle };
    hasError = rowData.cellCustoms[dataKey]?.hasError || false;
    isNegative = rowData.cellCustoms[dataKey]?.isNegative || false;
  }

  const getCellClassName = () => {
    return clsx(
      classes.tableCell,
      `MuiVirtualizedTable-column-${dataKey}`,
      customClass,
      className,
      {
        [classes.hasClick]: columnIndex !== -1 && clickable,
        error: hasError,
        isNegative,
      }
    );
  };

  return (
    <TableCell
      component="div"
      className={getCellClassName()}
      variant="body"
      style={{ ...style, ...customStyle, height: rowHeight }}
      align={align}
      onClick={onClick}
    >
      {Component ? (
        <Component rowIndex={rowIndex} rowData={rowData} data={children} />
      ) : (
        children
      )}
    </TableCell>
  );
};

Cell.propTypes = {
  children: PropTypes.node,
};

export default Cell;
